<template>
  <div
    class="global-back-btn"
    :style="{ left: pos.x + 'px', top: pos.y + 'px' }"
    @mousedown="onDragStart"
    @touchstart="onDragStart"
  >
    <van-icon name="arrow-left" />
  </div>
</template>

<script>
const STORAGE_KEY = "globalBackBtnPos";
const BTN_SIZE = 36;
const DEFAULT_POS = { x: 12, y: 12 };
const DRAG_THRESHOLD = 5;

function loadPos() {
  try {
    const saved = sessionStorage.getItem(STORAGE_KEY);
    if (saved) {
      const parsed = JSON.parse(saved);
      if (typeof parsed.x === "number" && typeof parsed.y === "number") {
        return parsed;
      }
    }
  } catch (e) {
    /* ignore */
  }
  return { ...DEFAULT_POS };
}

export default {
  name: "GlobalBackBtn",

  data() {
    return {
      pos: loadPos(),
      dragging: false,
      moved: false,
      dragOffset: { x: 0, y: 0 },
      dragStartPoint: { x: 0, y: 0 },
    };
  },

  mounted() {
    this.clampPos();
    window.addEventListener("resize", this.clampPos);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.clampPos);
    this.removeDragListeners();
  },

  methods: {
    clampPos() {
      const maxX = Math.max(0, window.innerWidth - BTN_SIZE);
      const maxY = Math.max(0, window.innerHeight - BTN_SIZE);
      this.pos = {
        x: Math.min(Math.max(0, this.pos.x), maxX),
        y: Math.min(Math.max(0, this.pos.y), maxY),
      };
    },

    savePos() {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(this.pos));
    },

    onDragStart(e) {
      const point = e.touches ? e.touches[0] : e;
      this.dragging = true;
      this.moved = false;
      this.dragStartPoint = { x: point.clientX, y: point.clientY };
      this.dragOffset = {
        x: point.clientX - this.pos.x,
        y: point.clientY - this.pos.y,
      };
      document.addEventListener("mousemove", this.onDragMove);
      document.addEventListener("mouseup", this.onDragEnd);
      document.addEventListener("touchmove", this.onDragMove, { passive: false });
      document.addEventListener("touchend", this.onDragEnd);
      document.addEventListener("touchcancel", this.onDragEnd);
    },

    onDragMove(e) {
      if (!this.dragging) return;
      const point = e.touches ? e.touches[0] : e;
      const distance = Math.hypot(
        point.clientX - this.dragStartPoint.x,
        point.clientY - this.dragStartPoint.y
      );
      if (!this.moved && distance < DRAG_THRESHOLD) return;

      e.preventDefault();
      this.moved = true;
      const maxX = Math.max(0, window.innerWidth - BTN_SIZE);
      const maxY = Math.max(0, window.innerHeight - BTN_SIZE);
      const x = point.clientX - this.dragOffset.x;
      const y = point.clientY - this.dragOffset.y;
      this.pos = {
        x: Math.min(Math.max(0, x), maxX),
        y: Math.min(Math.max(0, y), maxY),
      };
    },

    onDragEnd() {
      if (!this.dragging) return;
      this.dragging = false;
      this.removeDragListeners();
      if (this.moved) {
        this.savePos();
        return;
      }
      this.$router.back();
    },

    removeDragListeners() {
      document.removeEventListener("mousemove", this.onDragMove);
      document.removeEventListener("mouseup", this.onDragEnd);
      document.removeEventListener("touchmove", this.onDragMove);
      document.removeEventListener("touchend", this.onDragEnd);
      document.removeEventListener("touchcancel", this.onDragEnd);
    },
  },
};
</script>

<style scoped>
.global-back-btn {
  position: fixed;
  width: 36px;
  height: 36px;
  z-index: 9999;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.35);
  color: #fff;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  touch-action: none;
}
</style>
